export enum KycDocumentNames {
  ProofOfLife = 'proof_of_life',
  ProofOfAddress = 'proof_of_address',
  Website = 'website',
  CompanyComposition = 'company_composition',
  CertificateOfIncorporation = 'certificate_of_incorporation', // name saved in kyc_info (comes from dlocal)
  PowerOfAttorney = 'power_of_attorney',
  StatusDropDown = 'status_drop_down',
  CopyOfId = 'copy_of_id',
  CopyOfIdFront = 'copy_of_id_front',
  CopyOfIdBack = 'copy_of_id_back',
  UboCopyOfIdFront = 'ubo_copy_of_id_front',
  UboCopyOfIdBack = 'ubo_copy_of_id_back',
  CompanyInformationTaxId = 'company_information.tax_id',
  Selfie = 'selfie',
  Unknown = 'unknown',
}
